<template>
    <div>
        <HeadCommon></HeadCommon>
        <div class="main">
            <div class="my-bg flex-aic">
                <div class="title flex-aic" style="background-image: linear-gradient(90deg, rgba(8, 207, 222, 0) 0%, rgba(8, 207, 222, 0.4) 50.62%, rgba(8, 207, 222, 0) 100%);">
                    <h1>VR虚拟仿真环境教学</h1>
                    <p>打造沉浸式交互体验</p>
                </div>
            </div>
            <div class="my-simulation module">
                <div class="container">
                    <div class="title">
                        <h2>虚拟仿真</h2>
                    </div>
                    <!-- 虚拟仿真技术 -->
                    <div class="list flex-aic">
                        <div class="item up" v-for="item in simulationList" :key="item.id">
                            <div class="img">
                                <img :src="item.img" alt="">
                            </div>
                            <div class="text">
                                <p>{{ item.title }}</p>
                                <span>
                                   {{ item.content }}
                                </span>
                                <!-- <router-link to="/product">
                                    <div class="btn">查看详情</div>
                                </router-link> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-programme module">
                <div class="hui-bg">
                    <div class="container">
                        <div class="title">
                            <h2>解决方案</h2>
                        </div>
                        <div class="bg-box">
                            <div class="tab">
                                <div class="item" v-for="(item,index) in solutionList" :key="index"
                                    :class="{ 'item': true, 'active': activeTab === index }" @click="changeTab(index)">{{
                                        item.title }}</div>
                                <!-- <div class="item active">CAVE沉浸式虚拟现实显示系统</div>
                            <div class="item">大空间互动方案</div> -->
                            </div>
                            <div class="img">
                                <img :src="solutionList[activeTab].img" alt="">
                            </div>
                            <p>
                                {{ solutionList[activeTab].content }}
                            </p>
                        </div>
                    </div>
                </div>

            </div>
            <div class="my-about module">
                <div class="container">
                    <div class="title">
                        <h2>关于我们</h2>
                    </div>
                </div>
                <div class="brief">
                    <div class="item text-box">
                        <div class="text">
                            <h2 style="font-size: 20px;font-weight: 600;">公司简介</h2>
                            <p>
                                {{ company_profile }}
                            </p>
                        </div>
                    </div>
                    <div class="item img">
                        <img src="../img/about-bg.png" alt="">
                    </div>
                </div>
                <div class="bg">
                    <div class="container">
                        <div class="advantage">
                            <h4>公司具备的优势</h4>
                            <!-- 具备优势 -->
                            <div class="list">
                                <div class="item" v-for="item in advantageList" :key="item.id">
                                    <p>{{ item.title }}</p>
                                    <span>{{ item.content }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="industry">
                            <h4>现参与的虚拟仿真行业</h4>
                            <!-- 参与虚拟仿真行业 -->
                            <div class="list">
                                <div class="item" v-for="item in joinIndustryList" :key="item.id">
                                    <div class="img">
                                        <img :src="item.img" alt="">
                                    </div>
                                    <div class="text-box">
                                        <span>—— {{ item.name }} ——</span>
                                    </div>
                                    <p style="color: #fff;">{{ item.name }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="my-news">
                            <div class="title">
                                <h2>新闻动态</h2>
                            </div>
                            <!-- 新闻动态 -->
                            <div class="list">
                                <div class="item" v-for="item in newsList" :key="item.id">
                                    <div class="img">
                                        <img :src="item.img" alt="">
                                    </div>
                                    <div class="text">
                                        <p class="text-p">{{ item.title}}</p>
                                        <span style="color: #fff;">{{ item.show_time }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="btn more" @click="handleClick">查看更多</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-contact_us module">
                <div class="container">
                    <div class="title">
                        <h2>联系我们</h2>
                    </div>
                    <div class="map">
                        <div id="map-index">
                            <!-- <img src="" alt=""> -->
                            <MapContainer></MapContainer>
                        </div>
                        <!-- 地址 -->
                        <div class="address">
                            <h2>{{ company }}</h2>
                            <div class="item">
                                <div class="icon">
                                    <img src="../img/a1.png" alt="">
                                </div>
                                <div class="text">
                                    <p>地址：</p>
                                    <span>{{ us_address }}</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="icon">
                                    <img src="../img/a2.png" alt="">
                                </div>
                                <div class="text">
                                    <p>电话：</p>
                                    <span>{{ us_phone }}</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="icon">
                                    <img src="../img/a3.png" alt="">
                                </div>
                                <div class="text">
                                    <p>邮箱：</p>
                                    <span>{{ us_mail }}</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="icon">
                                    <img src="../img/a4.png" alt="">
                                </div>
                                <div class="text">
                                    <p>QQ号：</p>
                                    <span>{{ us_qq }}</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="icon">
                                    <img src="../img/a5.png" alt="">
                                </div>
                                <div class="text">
                                    <p>微博号：</p>
                                    <span>{{ us_wb }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <FootCommon></FootCommon>
    </div>
</template>
  
<script>
import HeadCommon from '@/components/HeadCommon.vue';
import FootCommon from '@/components/FootCommon.vue';
import MapContainer from '@/components/MapContainer.vue';
import { addressList } from "@/api/index";
export default {
    name: 'ShouYe',
    components: {
        HeadCommon,
        FootCommon,
        MapContainer
    },
    data() {
        return {
            us_address: '',
            us_phone: '',
            us_mail: '',
            us_qq: '',
            us_wb: '',
            company_name: '',
            // 公司简介
            company_profile: '',
            // 虚拟仿真的数据
            simulationList: [],
            // 解决方案
            solutionList: [],
            activeTab: 0,
            // 参与的虚拟仿真行业
            joinIndustryList: [],
            // 优势
            advantageList: [],
            // 新闻动态
            newsList: [],
            listPages:[],
            itemsToShow: 8, // 每次显示的条目数量
            showMoreButton: true, // 控制显示更多按钮
        }
    },
    created() {
        this.addressList()
    },
    computed: {
    visibleList() {
      // 只返回前 itemsToShow 条目的数据
      return this.listPages.slice(0, this.itemsToShow);
    },
  },
    methods: {
        async addressList() {
            const { data } = await addressList()
            // console.log(data);
            this.company = data.company
            this.us_address = data.us_address
            this.us_phone = data.us_phone
            this.us_mail = data.us_mail
            this.us_qq = data.us_qq
            this.us_wb = data.us_wb
            this.company_profile = data.company_profile
            // 虚拟仿真
            this.simulationList = data.simulationList
            // 解决方案
            this.solutionList = data.solutionList
            this.joinIndustryList = data.joinIndustryList
            this.advantageList = data.advantageList
            this.newsList = data.newsList
            this.listPages = data.listPages
        },
        changeTab(index) {
            this.activeTab = index; // 切换激活的Tab
        },
        handleClick() {
            this.$router.push('/news');
        },
        showAllItems() {
      // 点击"查看更多"按钮时显示所有数据
      this.itemsToShow = this.listPages.length;
      this.showMoreButton = false;
    },
    }
}
</script>
  
<style scoped>@import '../style/index.css';</style>